const translations = {
  "en": {
    "Share Preview": "Share Preview"
  },
  "zh-tw": {
    "Share Preview": "分享預覽"
  }
};

export default translations;
